function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
import { Component } from "react";
import { captureException } from "@sentry/browser";
import logger from "../../logger";
import track from "../../track";
var RENDER_ERROR_EVENT_ID = 281;
var ErrorBoundary = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(ErrorBoundary, Component);
    function ErrorBoundary(props) {
        var _this;
        _this = Component.call(this, props) || this;
        _this.state = {
            hasError: false
        };
        var fallback = props.fallback;
        if (fallback === undefined) {
            logger.warn("ErrorBoundary fallback not set!");
        }
        return _this;
    }
    var _proto = ErrorBoundary.prototype;
    _proto.componentDidCatch = function componentDidCatch(error) {
        var name = this.props.name;
        var message = 'Lapel Rendering Error: "' + name + '", ' + error;
        logger.error(message);
        captureException(message);
        track(RENDER_ERROR_EVENT_ID, name);
    };
    _proto.render = function render() {
        var hasError = this.state.hasError;
        var _this_props = this.props, _this_props_children = _this_props.children, children = _this_props_children === void 0 ? null : _this_props_children, _this_props_fallback = _this_props.fallback, fallback = _this_props_fallback === void 0 ? null : _this_props_fallback;
        if (hasError) {
            return fallback;
        }
        return children;
    };
    ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError() {
        return {
            hasError: true
        };
    };
    return ErrorBoundary;
}(Component);
export { ErrorBoundary };

//# sourceMappingURL=ErrorBoundary.js.map